import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react"
import Cookies from 'js-cookie';
// import handleLogout from '../../utilities/handleFunctions/HandleLogout';
import AdminHeaderNotifi from './components/AdminHeaderNotifi';
import { useTranslation } from 'react-i18next';
// import { apiFetchAdmin } from '../../../helpers/apiFetch';


export default function AdminAccount() {
    const [isLogIn, setIsLogIn] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {
        // if (localStorage.getItem("adminToken")) {
        if (Cookies.get('adminToken')) {
            // if (profile) {
            setIsLogIn(true)
        } else {
            setIsLogIn(false)
        }
    }, [isLogIn]);


    return (
        <div className="user-icon d-flex flex-nowrap dropdown pt-2 pt-sm-0 align-items-center">
            {!isLogIn ?
                <FontAwesomeIcon icon={faUser} className="user-account text-white bg-dark-beige" />
                :
                <>
                    <AdminHeaderNotifi />

                    <FontAwesomeIcon icon={faUser} className="user-account text-white bg-dark-orange" id="adminDropdown" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false" />

                    <ul className="dropdown-menu dropdown-menu-end text-end bg-light-beige border-white" aria-labelledby="adminDropdown">
                        <li>
                            <Link className="dropdown-item text-white"
                                onClick={() => {
                                    Cookies.remove("adminToken");
                                    setIsLogIn(false);
                                }}
                                to="/">
                                <FontAwesomeIcon className='me-3'
                                    icon={faArrowRightFromBracket} />
                                تسجيل الخروج</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-white" to={`/${i18n.language}/contact-us`}>المساعدة والدعم
                            </Link>
                        </li>
                    </ul>
                </>
            }
        </div>
    )
};

export { AdminAccount };


